import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchProducer(organization_id, producer_id) {
    return RequesterV1.get(
      `organization/partners/query_producers/show_producer/${organization_id}/producer/${producer_id}`
    );
  },
  fetchProducerCropFields(organization_id, producer_id) {
    return RequesterV1.get(
      `organization/partners/query_producers/show_producer/${organization_id}/producer_crop_fields/${producer_id}`
    );
  },
  fetchAttributeProducers(organization_id) {
    return RequesterV1.get(
      `organization/partners/query_producers/show_producer/${organization_id}/attribute_producers`
    );
  }
};
